import {Experiment, isExperiment} from './types';

export const getExperimentValue = (
  experiment?: Experiment | readonly Experiment[],
): string | boolean => {
  if (!experiment) return false;

  if (Array.isArray(experiment)) {
    const foundExperiment: Experiment = experiment.find(exp => exp.mapping);
    return (
      (foundExperiment?.mapping && Object.keys(foundExperiment.mapping)[0]!) ||
      false
    );
  }

  if (isExperiment(experiment)) {
    return Object.keys(experiment.mapping)[0]!;
  }

  return false;
};
